import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/layout/ProtectedRoute";
import Login from "./pages/Login";
import ReferrerOnboarding from "./pages/ReferrerOnboarding";
import RequireReferrer from "./pages/RequireReferrer";
import Dashboard from "./pages/Dashboard";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
 
          <Route element={<ProtectedRoute />}>
            <Route path="/onboarding" element={<ReferrerOnboarding />} />
 
            <Route element={<RequireReferrer />}>
              <Route path="/" element={<Dashboard />} />
            </Route>
          </Route>
 
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

// npm run build
// firebase deploy
